import React from "react"
import { FiStar } from "react-icons/fi"
import {
  Flex,
  Stack,
  Box,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  SimpleGrid,
} from "@chakra-ui/core"
import { GameDetailsPageData } from "../types"
import Screenshot from "./Screenshot"

interface Props {
  data: GameDetailsPageData
}

const GameFeatures: React.FC<Props> = ({ data }) => {
  return (
    <Flex
      color="gray.600"
      backgroundColor="orange.50"
      p={6}
      alignItems="center"
      justifyContent="center"
    >
      <Box flex={1} maxWidth={600}>
        <Heading
          textAlign="center"
          fontFamily="Lobster"
          as="h2"
          fontSize="4xl"
          mb={6}
        >
          {data.description.title}
        </Heading>
        <Text fontSize="2xl" mb={6}>
          {data.description.subTitle}
        </Text>
        <List spacing={2}>
          {data.description.features.map((feature, index) => {
            return (
              <ListItem key={index} fontSize="lg">
                <ListIcon as={FiStar} color="green.500" />
                {feature.text}
              </ListItem>
            )
          })}
        </List>
      </Box>
    </Flex>
  )
}

export default GameFeatures
